import React from 'react';
import { motion } from 'framer-motion';
import './Contact.css';

const Contact = () => {
  return (
    <section id="contact" className="contact section">
      <div className="container">
        <div className="section-header text-center mb-4">
          <h2>Visit Us Today</h2>
          <p>Ready to enhance your natural beauty? Visit us at our salon for professional beauty services!</p>
        </div>
        
        <div className="contact-info">
          {[
            { icon: 'fas fa-map-marker-alt', title: 'Location', content: 'No9 Cross Crescent\nRumuibekwe Port Harcourt' },
            { icon: 'fas fa-phone', title: 'Phone', content: '08147859422' },
            { icon: 'fas fa-clock', title: 'Hours', content: 'Mon - Sat: 8:00 AM - 6:00 PM\nSunday: 10:00 AM - 4:00 PM' }
          ].map((info, index) => (
            <motion.div 
              key={index}
              className="info-item"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.2, duration: 0.6 }}
              whileHover={{ y: -5, scale: 1.02 }}
            >
              <motion.div 
                className="info-icon"
                whileHover={{ scale: 1.1, rotate: 5 }}
                transition={{ type: "spring", stiffness: 300 }}
              >
                <i className={info.icon}></i>
              </motion.div>
              <div className="info-content">
                <h4>{info.title}</h4>
                <p>{info.content.split('\n').map((line, i) => (
                  <span key={i}>{line}{i < info.content.split('\n').length - 1 && <br />}</span>
                ))}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Contact;